import { Briefcase, Code, GraduationCap, LucideIcon } from "lucide-react";
import React from "react";
import { Timeline, TimelineItem } from "../common/timeline";

export interface NewExperienceItemType {
  position: "left" | "right";
  title: string;
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  date: string;
  description?: string;
  bullets?: string[];
  skills: string[];
  company?: string;
  companyLocation?: string;
  location?: string;
  type?: "internship" | "experience";
}

// claude
const ExperienceTimeline = () => {
  const experiences: NewExperienceItemType[] = [
    {
      position: "left",
      icon: Briefcase,
      title: "Full-Stack Web Developer | Cloud Specialist | Tester",
      //   date: "2023 - Present",
      date: "Oct 2022 - June 2025",
      company: "B2b Alive Ltd.",
      companyLocation: "London, UK",
      location: "Tunis, Tunisia",
      //   description:
      //     "Leading development of scalable web applications using React, Node.js, and cloud technologies. Mentoring junior developers and architecting solutions for complex business requirements.",
      description:
        "Leading development of scalable cloud-native web application for digital signage using MERN Stack, Graphql, AWS for avdertising purposes for clients companies. Collaborated with known companies (HP, Shell, Carrefour, Nissan, HP, Mercedes, etc), worked on feature implementation and code reviews.",
      skills: ["React", "Node.js", "AWS", "TypeScript", "PostgreSQL"],
      bullets: [
        "Led development of a MERN-based digital signage platform handling 1,000+ users and 10,000+ global screens for 100+ enterprise clients",
        "Implemented OAuth2, JWT, SSO & MFA, achieving 98% uptime and greatly enhancing security",
        "Migrated 100+ REST endpoints to GraphQL cutting data payloads by 55%, boosting API response times and contentupdate reliability reached 99%",
        "Containerized services via Docker and orchestrated with Kubernetes, lifting scalability and throughput by ~65%",
        "Built real-time content updates using Redis Pub/Sub and WebSocket notifications across distributed networks",
        "Switched frontend build tooling from Webpack to Vite.js, shrinking bundle size by 30% and accelerating dev server startup by 45%",
        "Designed React UIs with multi-language support, integrated AI chatbots, and canvas-based editors, improving content creation efficiency by 80%",
        "Deployed ELK stack for monitoring, reducing mean time to recovery (MTTR) by 35% and system crashes by 90%",
      ],
      type: "experience",
    },
    {
      position: "right",
      icon: Code,
      title: "Final Year Engineering Intern | Full Stack Developer",
      company: "3S Group",
      location: "Charguia, Tunisia",
      date: "Jan 2022 - Sept 2022",
      //   date: "2021 - 2023",
      bullets: [
        "Developed Canva-style editor platform using MERN Stack for managing digital content on 100+ screen players",
        "Integrated AWS S3 and Redis Pub/Sub for workflow automation, boosting deployment efficiency by 60%",
        "Created modular drag-and-drop components with live preview functionality, accelerating content assembly by 40%",
      ],
      skills: ["JavaScript", "Vue.js", "Python", "MongoDB", "Docker"],
      type: "experience",
    },
    {
      position: "left",
      icon: Code,
      title: "Second Year Engineering Intern",
      company: "3S Group",
      // companyLocation: "Tunis, Tunisia",
      location: "Charguia, Tunisia",
      date: "July 2021 - Sept 2021",
      //   title: "Full Stack Developer",
      //   date: "2021 - 2023",

      description:
        "Developed and maintained multiple client projects using modern web technologies. Collaborated with cross-functional teams to deliver high-quality software solutions on time.",
      skills: ["JavaScript", "Vue.js", "Python", "MongoDB", "Docker"],
      type: "experience",
    },
    {
      position: "right",
      icon: GraduationCap,
      //   title: "Computer Science Degree",
      //   date: "2017 - 2021",
      title: "Junior Engineering Intern",
      company: "3S Group",
      location: "Charguia, Tunisia",
      date: "June 2020 - Aug 2020",
      description:
        "Built responsive web interfaces and improved user experience. Worked with modern frameworks and maintained high code quality standards.",
      //   description:
      // "Assisted in developing company website and internal tools. Gained experience in agile development and version control systems.",
      skills: [
        "Data Structures",
        "Algorithms",
        "System Design",
        "Machine Learning",
      ],
      type: "internship",
    },
    // {
    //   position: "right",
    //   icon: Award,
    //   //   title: "First Developer Role",
    //   //   date: "2020",
    //   title: "Junior Engineering Intern",
    //   company: "3S Group",
    //   location: "Charguia, Tunisia",
    //   date: "June 2020 - Aug 2020",
    //   //   description:
    //   //     "Completed Bachelor of Science in Computer Science with honors. Focused on software engineering, algorithms, and distributed systems. Active member of coding club and hackathons.",
    //   description:
    //     "Started professional journey as a junior developer intern. Built responsive web applications and gained hands-on experience with agile development practices.",
    //   skills: ["HTML/CSS", "JavaScript", "Git", "REST APIs", "Agile"],
    //   type: "internship",
    // },
  ];

  return (
    <Timeline title="My Professional Journey">
      {experiences.map((exp, index) => (
        <TimelineItem
          key={index}
          {...exp}
          delay={index * 0.1}
          //   position={exp.position}
          //   icon={exp.icon}
          //   title={exp.title}
          //   date={exp.date}
          //   description={exp.description}
          //   skills={exp.skills}
        />
      ))}
    </Timeline>
  );
};

export default ExperienceTimeline;
